import { TransparantIcon, IconTextButton } from "./Button/IconButton";
import { useState, useContext, useRef, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { Auth } from "aws-amplify";
import AuthContext from "../contexts/AuthContext";
import db from "./../common/db";

const HeaderProfile = ({ className }) => {
  const [open, setOpen] = useState(false);
  const navigate = useNavigate();
  const Context = useContext(AuthContext);
  const wrapperRef = useRef("menu");

  const logout = async () => {
    try {
      await Auth.signOut();
      window.localStorage.clear();
      db.delete();
      Context.setValue({
        user: { attributes: {} },
        signedIn: false,
        refreshToken: null,
        domain: null,
      });
      // window.location.reload();
    } catch (err) {
      console.log("Logout err - ", err);
    }
  };

  const ClickOutside = (ref, onClickOutside) => {
    // Function to close dropdown when clicked anywhere outside
    useEffect(() => {
      // Invoke Function onClick outside of element
      function handleClickOutside(event) {
        if (ref.current && !ref.current.contains(event.target)) {
          onClickOutside();
        }
      }
      // Bind
      document.addEventListener("mousedown", handleClickOutside);
      return () => {
        // dispose
        document.removeEventListener("mousedown", handleClickOutside);
      };
    }, [ref, onClickOutside]);
  };

  ClickOutside(wrapperRef, () => {
    setOpen(false);
  });

  return (
    <div
      className={`position-relative ${className ? className : ""}`}
      ref={wrapperRef}
    >
      <TransparantIcon onClick={() => setOpen(!open)} className="p-0">
        <img src="icons/profile-icon.svg" alt="profile"></img>
      </TransparantIcon>
      {open && (
        <div className="d-flex flex-column tooltip-arrow mt-2 position-absolute">
          <IconTextButton
            btnOrder="first"
            icon="icons/profile-icon-orange.svg"
            onClick={() => navigate("/profile")}
          >
            Profile
          </IconTextButton>
          <IconTextButton
            btnOrder="second"
            icon="icons/logout.svg"
            onClick={() => {
              logout();
            }}
          >
            Logout
          </IconTextButton>
        </div>
      )}
      <style>
        {`
            .tooltip-arrow{
                right: -34%;
                z-index: 100;
                filter: drop-shadow(0px 4px 4px rgba(0, 0, 0, 0.25));
            }
            .tooltip-arrow::after{
                content: "";
                position: absolute;
                bottom: 99%;
                left: 75%;
                margin-left: -5px;
                border-width: 8px;
                border-style: solid;
                border-color: transparent transparent var(--white) transparent;
            }
            `}
      </style>
    </div>
  );
};

export default HeaderProfile;
